import * as Moment from "moment";
import { ManagementTokenInformation, ManagementTokenPublishResult } from "../../domain/system";
import { IManagementTokenInformationBean, IManagementTokenPublishResultBean } from "./beans";

export class ManagementTokenTranslator {
  public static toManagementTokenPublishResult(bean: IManagementTokenPublishResultBean): ManagementTokenPublishResult {
    if (!bean) { return null; }
    const result = new ManagementTokenPublishResult();
    result.token = bean.token;
    result.tokenLifeSpan = bean.tokenLifeSpan;
    result.conflictInformations = this.toManagementTokenInformations(bean.conflictInformations);
    return result;
  }

  private static toManagementTokenInformations(beans: IManagementTokenInformationBean[]): ManagementTokenInformation[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toManagementTokenInformation(bean));
  }

  private static toManagementTokenInformation(bean: IManagementTokenInformationBean): ManagementTokenInformation {
    const info = new ManagementTokenInformation();
    info.token = bean.token;
    info.userName = bean.userName;
    info.terminalName = bean.terminalName;
    info.editStartDateTime = this.toDate(bean.editStartDateTime);
    return info;
  }

  private static toDate(dateTimeAsString: string): Date {
    if (!dateTimeAsString) { return new Date(); }
    const parsedDateTime = Moment(dateTimeAsString, "YYYYMMDDHHmmss").toDate();
    return !parsedDateTime
      ? new Date()
      : parsedDateTime;
  }
}
